import { apolloProvider } from '@/modules/myStageGraphQL';
import { DELETE_CHAT_MESSAGE } from '@/graphql/chatHistory';

import logger from '@/modules/Logger';

export const DeleteChatMessageService = {
  msb: async (params, callback) => {
    logger.info(`[Chat Delete] Update chat message from MSB endpoint`, {
      operation: 'chat-history:delete'
    });

    const client = apolloProvider.defaultClient;
    const payload = {
      student_book_id: parseInt(params.lessonId),
      message_id: parseInt(params.messageId)
    };

    try {
      const { data } = await client.mutate({
        mutation: DELETE_CHAT_MESSAGE,
        fetchPolicy: 'no-cache',
        variables: payload
      });

      if (data?.deleteChatMessage) {
        callback(data?.deleteChatMessage);
      } else {
        logger.error(`[Chat Delete] Empty result from delete of MSB GraphQL API`, {
          operation: 'chat-history:delete',
          event_type: 4,
          payload: payload
        });
      }
    } catch (error) {
      logger.error(`[Chat Delete] Error deleting chat data`, {
        error: error.message,
        operation: 'chat-history:delete'
      });
      callback(null);
    }

    return true;
  },

  legacy: async (params, callback) => {
    logger.info(`[Chat Delete] Delete chat message from LEGACY endpoint - skipped`, {
      operation: 'chat-history:delete',
      payload: {
        params, callback
      }
    });

    callback(null);
    
    return false;
  }
};
